<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="medium"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_fabric_no') || '面料编号'"
            ref="material"
            prop="fabricNo"
          >
            <el-input clearable v-model="formData.fabricNo" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="() => (chooseFabricDialogVisible = true)"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item
            :label="$l('form_label_fabricPosition') || '面料位置'"
            prop="fabricPosition"
          >
            <dict-select
              v-model="formData.fabricPosition"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricPosition' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="medium"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item
            :label="
              $l('form_label_Fabric_identification_name') || '面料识别名称'
            "
            prop="fabricIdentifyName"
          >
            <el-input v-model="formData.fabricIdentifyName" disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_fabric_unit') || '面料单位'">
            <dict-select
              v-model="formData.fabricUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'fabricYarnUnit' }"
              size="medium"
              filterable
              clearable
              disabled
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_fabric_width') || '门幅'">
            <el-input v-model="formData.fabricWidth" disabled> </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_fabricWeight') || '面料克重'">
            <el-input v-model="formData.fabricWeight" disabled> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_fabricLoss') || '损耗'">
            <el-input-number
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="2"
              :step="0.01"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.fabricLoss"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item
            :label="$l('form_label_net_unit_consumption') || '净单耗'"
          >
            <el-input-number
              controls-position="right"
              style="width: 100%"
              :min="0"
              :step="0.001"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.unitQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_fabricQty') || '耗料'">
            <el-input-number
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="3"
              :step="0.001"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.fabricQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item
            :label="$l('form_label_total_material_consumption') || '合计耗料'"
          >
            <el-input-number
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="3"
              :step="0.01"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.subQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>

    <choose-fabric-dialog
      :title="'添加面料信息'"
      :visible.sync="chooseFabricDialogVisible"
      type="radio"
      @confirm="onFabricConfirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    techGoodsFabricCode: { type: String, default: '' },
    techGoodsSpecCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      chooseFabricDialogVisible: false,
      formData: { fabricNo: '', fabricPosition: '', fabricIdentifyName: '' },
      productLineParams: { dictType: 'productLine' },
      mainMaterialParams: {},
      detailMaterialParams: {},
      rules: {
        fabricPosition: [
          {
            required: true,
            message:
              this.$l('pe_select_label_fabricPosition') || '请选择面料位置',
            trigger: 'change',
          },
        ],
        fabricIdentifyName: [
          {
            required: true,
            message:
              this.$l('pe_input_Fabric_identification_name') ||
              '请输入面料识别名称',
            trigger: 'change',
          },
        ],
        fabricNo: [
          {
            required: true,
            message: this.$l('pe_select_label_fabric') || '请选择面料',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techGoodsFabricCode) return
      this.$api
        .techGoodsFabricDetailApi({
          techGoodsFabricCode: this.techGoodsFabricCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      const parms = {
        ...this.formData,
        techGoodsSpecCode: this.techGoodsSpecCode,
      }

      this.loadingOpen()
      //根据不同的操作调用不同接口
      let saveApi = {}
      if (!this.techGoodsFabricCode) {
        saveApi = this.$api.techGoodsFabricAddSaveApi(parms)
      } else {
        saveApi = this.$api.techGoodsFabricEditSaveApi(parms)
      }
      saveApi
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    onFabricConfirm(data) {
      this.formData.fabricCode = data.fabricCode
      this.formData.fabricNo = data.fabricNo
      this.formData.fabricUnit = data.fabricUnit
      this.formData.fabricWidth = data.wid
      this.formData.fabricWeight = data.fabricWeight
      this.formData.fabricIdentifyName =
        data.fabricName + ' ' + data.fabricNameEn
    },
  },
}
</script>
